module.exports = __webpack_public_path__ + "img/3.9bf94006.jpg";